//#region src/domain/i18n/country-code.ts
var CountryCode = /* @__PURE__ */ function(CountryCode) {
	CountryCode["DO"] = "DO";
	CountryCode["GT"] = "GT";
	CountryCode["HN"] = "HN";
	CountryCode["PE"] = "PE";
	return CountryCode;
}({});
//#endregion
export { CountryCode };

//# sourceMappingURL=country-code.js.map